// This file can be replaced during build by using the `fileReplacements` array.
// `ng build --prod` replaces `environment.ts` with `environment.prod.ts`.
// The list of file replacements can be found in `angular.json`.

export const environment = {
  production: false,
  firebase: {
    apiKey: 'AIzaSyBaEWla7NUcrfFIgW61DWCFhSSZZXU54E8',
    authDomain: 'medicina-uniandes.firebaseapp.com',
    databaseURL: 'https://medicina-uniandes-default-rtdb.firebaseio.com',
    projectId: 'medicina-uniandes',
    storageBucket: 'medicina-uniandes.appspot.com',
    messagingSenderId: '370430901065',
    appId: '1:370430901065:web:c41be8a16696795ea87898',
    measurementId: 'G-NFST5TX96T'
  }
};

/*
 * For easier debugging in development mode, you can import the following file
 * to ignore zone related error stack frames such as `zone.run`, `zoneDelegate.invokeTask`.
 *
 * This import should be commented out in production mode because it will have a negative impact
 * on performance if an error is thrown.
 */
// import 'zone.js/dist/zone-error';  // Included with Angular CLI.
